import { useEffect, useState } from 'react';
import { useAppStore } from '../../store/useAppStore';

interface HelperProps {
  type: 'scroll' | 'click';
}

export const Helper: React.FC<HelperProps> = ({ type }) => {
  const [show, setShow] = useState(false);
  const [hasClicked, setHasClicked] = useState(false);
  const { isInitialAnimationComplete, hasScrolled, selectedIndex } =
    useAppStore();

  useEffect(() => {
    if (selectedIndex !== null && !hasClicked) {
      setHasClicked(true);
    }
  }, [selectedIndex]);

  useEffect(() => {
    if (type === 'scroll') {
      // Le scroll helper s'affiche après l'animation initiale
      if (
        isInitialAnimationComplete &&
        !hasScrolled &&
        selectedIndex === null
      ) {
        const timer = setTimeout(() => {
          setShow(true);
        }, 500);
        return () => clearTimeout(timer);
      }
      setShow(false);
    } else if (type === 'click') {
      // Le click helper s'affiche uniquement après que l'utilisateur ait scrollé
      // et disparaît définitivement après le premier clic
      if (hasScrolled && !hasClicked && selectedIndex === null) {
        const timer = setTimeout(() => {
          setShow(true);
        }, 500);
        return () => clearTimeout(timer);
      }
      setShow(false);
    }
  }, [
    isInitialAnimationComplete,
    hasScrolled,
    hasClicked,
    type,
    selectedIndex,
  ]);

  if (!show) return null;

  return (
    <div className="fixed text-black text-sm z-10 pointer-events-none left-1/2 -translate-x-1/2 bottom-[21vh] md:left-8 md:bottom-8 md:translate-x-0">
      <div
        className="opacity-0"
        style={{
          animation: 'fade-in 0.6s ease-out forwards',
        }}
      >
        <div className="animate-float">
          {type === 'scroll'
            ? 'Scroll to explore my work'
            : 'Select a project for more information'}
        </div>
      </div>
    </div>
  );
};

export const ScrollHelper = () => <Helper type="scroll" />;
export const ClickHelper = () => <Helper type="click" />;
